// import _get from "lodash";
const CheckIncustomerParser = {};
CheckIncustomerParser.getCheckIncustomerParser = (res) => {
  if (!res) {
    return {};
  }

// const data = res.result.filter((item) => item.parent_id !== 0);

  if (res) {
  return res?.result;
   
  }
};  



export { CheckIncustomerParser };